import AddIcon from '@mui/icons-material/Add';
import { Box, Paper, Typography } from '@/shared/ui';

import { Permission } from '@/entities/permissions';
import UpgradeToPremiumButton from '@/features/_shared/UpgradeToPremium/UpgradeToPremiumButton';
import { usePermission } from '@/features/_shared/user';
import {
  ExpiredBannerType,
  useExpiredBannerContent
} from '@/features/profile/hooks/useExpiredBannerContent';
import KeyDialog from '@/features/profile/KeyDialog';
import Button from '@/shared/ui/primitives/Button';

import ApiKeyTable from './Table';
import useTokenGeneration from './useTokenGeneration';

const TokenGenerationComponent = () => {
  const { hasPermission } = usePermission();
  const isFeatureBlocked = !hasPermission(Permission.GenerateApiToken);
  const expiredBannerContent = useExpiredBannerContent();
  const { apiKeys, open, setOpen, error } = useTokenGeneration(!isFeatureBlocked);

  const upgradeButtonType =
    expiredBannerContent?.type === ExpiredBannerType.expired ||
    expiredBannerContent?.type === ExpiredBannerType.trialEndingSoon
      ? 'expired'
      : 'upgrade';

  return (
    <Box
      component={Paper}
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'space-between',
        p: 3,
        width: '100%'
      }}
    >
      <KeyDialog
        open={open}
        setOpen={setOpen}
      />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant='h6'>Token Generation</Typography>
        <Button
          disabled={isFeatureBlocked}
          size='small'
          startIcon={<AddIcon />}
          variant='contained'
          onClick={() => {
            setOpen(!open);
          }}
        >
          Generate new token
        </Button>
      </Box>
      {isFeatureBlocked && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography sx={{ py: 3 }}>
            GX Go Premium users can export data through our API and many other methods.
          </Typography>
          <UpgradeToPremiumButton type={upgradeButtonType} />
        </Box>
      )}
      {!isFeatureBlocked && (error || <ApiKeyTable apiKeys={apiKeys} />)}
    </Box>
  );
};

export default TokenGenerationComponent;
